import { Button } from '@purpur/library';
import styled from 'styled-components';

import { Modal } from '@telialt/common-modal/src';
import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const NarrowModal = styled(Modal)`
    min-height: unset;
    height: auto;
    margin: 1.75rem auto;
    width: calc(100% - 2rem);

    ${purpurMedia('lg')`
        width: 380px;
    `}
`;

export const BodyWrapper = styled.div`
    padding: ${getPurpurSpacing('800')} 0 ${getPurpurSpacing('400')} 0;
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: ${getPurpurSpacing('200')};
`;

export const TeliaBrandLogo = styled.img`
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const FooterButton = styled(Button)`
    ${purpurMedia('md')`
        align-self: center;
    `}
`;

export const DestructiveTextButton = styled(FooterButton)`
    color: ${getPurpurColor('red500')};

    &:hover {
        color: ${getPurpurColor('red500')};
        text-decoration: underline;
    }
`;
